/**
 * App 模块 - 应用全局状态
 * 参考 aegismaternity 项目的 appSlice.js
 */
import { createAsyncAction } from '../utils'
import Api from '@/service/api/repository/index'

// 初始状态
const initialState = {
  fetching: false,
  error: null,
  user: {
    id: '',
    token: '',
    store_id: '',
    department_id: '',
    department_name: '',
    username: '',
    user_name: ''
  }
}

// Mutations
const mutations = {
  SET_FETCHING(state, fetching) {
    state.fetching = fetching
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_USER_INFO(state, userInfo) {
    state.user = { ...state.user, ...userInfo.data }
  }
}

// Actions
const actions = {
  // 登录
  login: createAsyncAction(
    Api.loginApi.login,
    'SET_USER_INFO',
    (data) => ({
      ...data
    }),
    {
      pendingMutation: 'SET_FETCHING',
      errorMutation: 'SET_ERROR'
    }
  )
}

// Getters
const getters = {
  // 一次性返回完整 user 对象，组件里直接用 this.$store.getters['app/userInfo'] 即可
  userInfo: state => state.user,
  isLoggedIn: state => !!state.user.token,
  fetching: state => state.fetching,
  error: state => state.error
}

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/common/app.js